import React, { useMemo } from 'react'
import '../RecordDetailsPage.scss'
import { GraniteDataGrid } from '@tecuity/granite-ui'

const BranchingBusinessPanel = ({ fieldSettings = {}, businesses = [], title = '' }) => {
  const template = useMemo(() => {
    return Object.entries(fieldSettings).map(([key, val]) => ({
      field: key,
      flex: 0.5,
      headerName: val ? val.DisplayName : '',
      disableColumnMenu: true,
    }))
  }, [businesses])

  const tableRows = useMemo(() => {
    const rows = businesses.map((business, i) => {
      const row = {
        id: i,
      }
      Object.keys(fieldSettings).forEach((key) => {
        Object.assign(row, { [key]: business[key] })
      })
      return row
    })
    return rows
  }, [businesses])

  return (
    <div
      className="row"
      style={{ marginBottom: '80px', display: 'flex', flexDirection: 'row', gap: '20px' }}
    >
      <h2>{title}</h2>
      <GraniteDataGrid getRowId={(row) => row.id} columns={template} rows={tableRows} />
    </div>
  )
}

export default BranchingBusinessPanel
